import OrgsPage from './OrgsPage';
import { UserRole } from '@nova/core';
import OrgPage from './OrgPage';
import i18n from '@/plugins/i18n.js';

export default [
  {
    path: '/orgs',
    name: 'orgs',
    component: OrgsPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.orgs'),
      requiresAuth: true,
      minRole: UserRole.INTERNAL
    }
  },
  {
    path: '/org',
    name: 'org',
    props: false,
    component: OrgPage,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.myOrganization'),
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      minRole: UserRole.ADMIN
    }
  },
  {
    path: '/org/:orgId?/settings',
    name: 'org.settings',
    component: OrgPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.myOrganizationSettings'),
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      minRole: UserRole.ADMIN
    }
  },
  {
    path: '/org/:orgId?/loadtypes',
    name: 'org.loadtypes',
    component: OrgPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.myOrganizationLoadTypes'),
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      minRole: UserRole.ADMIN
    }
  },
  {
    path: '/org/:orgId?/ssoconfig',
    name: 'org.ssoconfig',
    component: OrgPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.myOrganizationSsoSetup'),
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      minRole: UserRole.ADMIN
    }
  },
  {
    path: '/org/:orgId?/warehouse-groups',
    name: 'org.warehouse-groups',
    component: OrgPage,
    props: true,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.myOrganizationWarehouseGroupsSetup'),
      requiresAuth: true,
      maxRole: UserRole.OWNER,
      minRole: UserRole.ADMIN
    }
  }
];
